import HeroBackground from "../components/HeroBackground";
import HeroVideo from "../components/HeroVideo";
import DownloadAppButton from "../components/DownloadAppButton";

export default function HeroSection() {
  return (
    <section id="home" className="relative scroll-mt-24 overflow-hidden isolate">
      <HeroBackground />
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-20 pt-4 sm:px-6 sm:pb-24 sm:pt-6 lg:px-8 lg:pb-28 lg:pt-8">
        <div className="mb-10 flex justify-center">
          <a
            href="https://www.producthunt.com/products/shadow-6?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_campaign=badge-shadow-2-0-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Shadow 2.0 - The work your meetings create, done before they end | Product Hunt"
              width="250"
              height="54"
              src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=1136553&theme=light&period=daily&t=1778147887528"
            />
          </a>
        </div>
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-12 md:gap-12">
          <div className="order-2 md:order-2 md:col-span-6 lg:col-span-6">
            <div className="mx-auto w-4/5 max-w-md md:ml-auto md:mr-0 md:max-w-none md:pl-4 lg:pl-8">
              <HeroVideo />
            </div>
          </div>

          <div className="order-1 text-center md:order-1 md:col-span-6 md:text-left lg:col-span-6">
            <h1 className="text-[clamp(2rem,4.5vw,3.5rem)] font-medium leading-[1.1] tracking-tight text-neutral-900">
              <span className="block">Shadow completes</span>
              <span className="block">your to-dos</span>
              <span className="block text-[#0092B4]">before you finish the call</span>
            </h1>
            <p className="mx-auto mt-5 max-w-md text-balance text-sm text-neutral-500 sm:text-base md:mx-0">
              Docs created. Data pulled. Follow-ups scheduled. Slides built. All while you stay in
              the conversation.
            </p>
            <div className="mt-6 flex justify-center md:justify-start">
              <DownloadAppButton size="md" withIcon location="hero" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
